import React, { memo } from 'react';

import { trans } from '../../localization';

import './Transfer.scss';

const Transfer = memo(() => {
  return (
    <div className="transfer-onboarding">
      <div className="transfer-onboarding-title">
        {trans('merchant_transfer_page_text_title')}
      </div>
      <p className="transfer-onboarding-content" dangerouslySetInnerHTML={{ __html: trans('merchant_transfer_page_text_content') }} />
    </div>
  );
});

Transfer.displayName = 'Transfer';

export default Transfer;



// WEBPACK FOOTER //
// ./foody/src/pages/Transfer/Transfer.jsx